module.exports = "/src/views/eternal-dev/businesses/gas-station/images/light/Ron/header-background.svg";